(function(){
    'use strict';

    /**
     * ===================================================
     * Form helpers
     * Add the following code if you want the name of the file appear on select
     * ===================================================
     */
    $('.sq-form-upload input').on('change', function() {

        var fileName = $(this).val().split('\\').pop();

        $(this).closest('.sq-form-question').find('.sq-form-question-title').addClass('selected').html(fileName);
    });


    /**
     * ===================================================
     * Form helpers
     * https://getbootstrap.com/docs/4.3/components/forms/#checkboxes
     * ===================================================
     */
    $('.sq-form-question-answer').each(function() {

        var $checkOrRadio = $(this);

        if( $($checkOrRadio).find(':radio').length > 0) {

            $($checkOrRadio).find('ul').wrap('<div class="custom-control custom-radio"></div>');
        }

        if( $($checkOrRadio).find(':checkbox').length > 0) {

            $($checkOrRadio).find('ul').wrap('<div class="custom-control custom-checkbox"></div>');
        }
    });

}());
